module.exports = __webpack_public_path__ + "5a10fa354fc2ce227dd90588afeb988c.png";